// extracted by mini-css-extract-plugin
export default {"wrapper":"PrivacyPolicy_wrapper__+xUih","title":"PrivacyPolicy_title__0k79+","inner":"PrivacyPolicy_inner__afGgP"};